let elements = document.querySelectorAll('.js-business-donation-subpage');

for (let element of elements) {
  element.addEventListener('click', (event) => {
    event.preventDefault();

    let checkboxes = document.querySelectorAll(
      '.js-donate-block-product-checkbox'
    );
    for (let checkbox of checkboxes) {
      checkbox.classList.remove('donate-block__product-checkbox--active');
    }

    let currentCheckbox = event.currentTarget.querySelector(
      '.js-donate-block-product-checkbox'
    );
    currentCheckbox.classList.add('donate-block__product-checkbox--active');

    document.querySelector('.js-business-own-blocks').style.display = 'none';

    for (const innerElement of document.querySelectorAll(
      `.js-business-dynamic-content`
    )) {
      innerElement.style.display = 'none';
    }

    let id = event.currentTarget.dataset.targetId;
    let target = document.querySelector(
      `.js-business-dynamic-content[data-id="${id}"]`
    );
    target.style.display = 'block';
    if (typeof window.wwffiRefreshAllGalleries === 'function') {
      window.wwffiRefreshAllGalleries();
    }

    target.scrollIntoView({ behavior: 'smooth' });
  });
}
